<script>
import {mapState, mapActions} from 'vuex';

export default {
    props: {
        tips: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            paused: false,
            overflowed: false,
            expanded: false,
            interval: undefined,
            wait: 15000
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            supplier: state => state.auth.supplier,
            open: state => state.info.open,
            page: state => state.info.page
        }),
    },
    created() {
        this.pageReset();
        if(this.open) {
            this.interval = setInterval(this.incrementPage, this.wait);
        }
    },
    methods: {
        ...mapActions({
            toggleInfoWidget: 'info/toggleInfoWidget',
            pageIncrement: 'info/pageIncrement',
            pageSelect: 'info/pageSelect',
            pageReset: 'info/pageReset'
        }),
        toggle() {
            if(!this.interval) {
                this.interval = setInterval(this.incrementPage, this.wait);
            }
            if(this.open) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            this.toggleInfoWidget();
            this.checkForOverflow();
        },
        setPage(index) {
            this.pageSelect(index);
            this.checkForOverflow();
        },
        checkForOverflow() {
            this.expanded = false;
            setTimeout(() => {
                const element = document.getElementById('info-widget__info-body');
                this.overflowed = element.scrollHeight > element.clientHeight;
            }, 1);
        },
        incrementPage() {
            if(this.open && !this.paused && this.tips.length > 1) {
                this.pageIncrement(this.tips.length).then(() => {
                    this.checkForOverflow();
                });
            }
        },
        clean() {
            if(this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
        }
    },
}
</script>
<template>
    <div class="info-widget">
        <div class="info-widget__toggle" @click="toggle">
            <i class="fa fa-question-circle"/>
        </div>
        <transition name="slide-fade" type="in-out">
            <div v-if="open" class="info-widget__container" @mouseenter="paused = true" @mouseleave="paused = false">
                <div class="info-widget__content">
                    <div class="info-widget__welcome">
                        {{ $t('tips.hi') }} {{ user.firstName }} {{ user.lastName }}
                    </div>
                    <div :class="['info-widget__tips', (expanded) ? 'info-widget__tips--expanded' : null]">
                        <div v-if="tips.length > 0" class="info-widget__info">
                            <div class="info-widget__info-title">
                                {{ $t( tips[page].title ) }}
                            </div>
                            <div id="info-widget__info-body" :class="['info-widget__info-body', (expanded) ? 'info-widget__info-body--expanded' : null]">
                                {{ $t( tips[page].body ) }}
                            </div>
                            <div v-if="overflowed && !expanded" class="info-widget__info-more" @click="expanded = !expanded">
                                ... {{ $t('tips.more') }}
                            </div>
                            <div v-if="overflowed && expanded" class="info-widget__info-less" @click="expanded = !expanded">
                                ... {{ $t('tips.less') }}
                            </div>
                        </div>
                    </div>
                    <transition name="slide-fade" type="in-out">
                        <div v-if="!expanded" class="info-widget__tips-controls">
                            <span v-for="(tip, index) in tips"
                                  :key="index"
                                  :class="['info-widget__tips-page', index === page ? 'info-widget__tips-page--selected' : null]"
                                  :value="index"
                                  @click="setPage(index)"/>
                        </div>
                    </transition>
                    <transition name="slide-fade" type="in-out">
                        <div v-if="!expanded" class="info-widget__contact">
                            <div class="info-widget__contact-header">
                                {{ $t('tips.help') }}
                            </div>
                            <div v-if="!user.contractManager" class="info-widget__contact-person">
                                <div class="info-widget__contact-name">{{ supplier.contactName }}</div>
                                <a :href="'mailto:' + supplier.contactEmail" class="info-widget__contact-email">{{ supplier.contactEmail }}</a>
                            </div>
                            <div v-if="user.contractManager" class="info-widget__contact-person">
                                <div class="info-widget__contact-name">{{ $t('tips.camping') }}</div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/InfoWidget/InfoWidget.vue